import { api } from "./api";
import { Currency } from "../types/currency.type";
import { ClientSpool, Spool, SpoolHolding, SpoolMovement } from "../types/spool.type";

export interface SpoolPayload {
  name: string;
  price: number;
  currency: Currency;
  exchangeRate: number;
  stock?: number;
}

export interface GiveReturnResult {
  message: string;
  client: {
    _id: string;
    spoolDebt: number;
    totalClientDebt: number;
    totalCompanyDebt: number;
  };
  holding: ClientSpool;
}

export interface PaySpoolPayload {
  clientId: string;
  spoolId: string;
  quantity: number;
  cashboxId: string;
  exchangeRate: number;
  description?: string;
}

export interface PaySpoolResult extends GiveReturnResult {
  transactionId: string;
}

export const spoolApi = {
  async getSpools(activeOnly = false): Promise<Spool[]> {
    const { data } = await api.get<Spool[]>("/spool", {
      params: activeOnly ? { activeOnly: "true" } : {},
    });
    return data;
  },
  async createSpool(payload: SpoolPayload): Promise<Spool> {
    const { data } = await api.post<Spool>("/spool", payload);
    return data;
  },
  async updateSpool(id: string, payload: Partial<SpoolPayload> & { isActive?: boolean }): Promise<Spool> {
    const { data } = await api.put<Spool>(`/spool/${id}`, payload);
    return data;
  },
  async deleteSpool(id: string): Promise<{ message: string }> {
    const { data } = await api.delete<{ message: string }>(`/spool/${id}`);
    return data;
  },
  async giveSpool(payload: { clientId: string; spoolId: string; quantity: number }): Promise<GiveReturnResult> {
    const { data } = await api.post<GiveReturnResult>("/spool/give", payload);
    return data;
  },
  async returnSpool(payload: { clientId: string; spoolId: string; quantity: number }): Promise<GiveReturnResult> {
    const { data } = await api.post<GiveReturnResult>("/spool/return", payload);
    return data;
  },
  async paySpool(payload: PaySpoolPayload): Promise<PaySpoolResult> {
    const { data } = await api.post<PaySpoolResult>("/spool/pay", payload);
    return data;
  },
  async getClientSpools(clientId: string): Promise<ClientSpool[]> {
    const { data } = await api.get<ClientSpool[]>(`/spool/client/${clientId}`);
    return data;
  },
  async getHoldings(spoolId?: string): Promise<SpoolHolding[]> {
    const { data } = await api.get<SpoolHolding[]>("/spool/holdings", {
      params: spoolId ? { spoolId } : {},
    });
    return data;
  },
  async getMovements(clientId?: string, limit = 100): Promise<SpoolMovement[]> {
    const { data } = await api.get<SpoolMovement[]>("/spool/movements", {
      params: { ...(clientId ? { clientId } : {}), limit },
    });
    return data;
  },
};
